module.exports = __webpack_public_path__ + "static/media/Name2Long.da12f5cd.png";